import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

// Единый раздел «Квесты»: три вкладки над списками задач, наград и выдачи наград.
const TABS = [
    { value: '/quests', label: 'Задачи' },
    { value: '/rewards', label: 'Награды' },
    { value: '/quest-purchases', label: 'Выдача наград' },
];

export const QuestSectionTabs = () => {
    const location = useLocation();
    const current = TABS.find(
        (tab) => location.pathname === tab.value || location.pathname.startsWith(`${tab.value}/`)
    )?.value || '/quests';

    return (
        <Box sx={{ mt: 1, mb: 2, p: .75, border: '1px solid', borderColor: 'divider', borderRadius: 2.5, bgcolor: 'background.paper', overflow: 'hidden' }}>
            <Tabs
                value={current}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ minHeight: 42, '& .MuiTabs-indicator': { display: 'none' }, '& .MuiTab-root': { minHeight: 42, borderRadius: 2, px: { xs: 2, md: 3 }, fontWeight: 750, textTransform: 'none' }, '& .Mui-selected': { bgcolor: 'action.selected' } }}
            >
                {TABS.map((tab) => (
                    <Tab
                        key={tab.value}
                        value={tab.value}
                        label={tab.label}
                        component={Link}
                        to={tab.value}
                    />
                ))}
            </Tabs>
        </Box>
    );
};
